export const getIndicatorIds = state => state.statementTemplate.indicatorIds;
